/** Sentinel value used by the dashboard to mark user-added entries as editable. */
export var CRQLAR_EXTRA_FIELD_SOURCE = 'crqlar';
